const es = {
  save: 'Guardar',
  selectSingle: 'Seleccionar fecha',
  selectMultiple: 'Seleccionar fechas',
  selectRange: 'Seleccionar periodo',
  notAccordingToDateFormat: inputFormat => `Formato de fecha debe ser ${inputFormat}`,
  mustBeHigherThan: date => `Debe ser posterior a ${date}`,
  mustBeLowerThan: date => `Debe ser anterior a ${date}`,
  mustBeBetween: (startDate, endDate) => `Debe estar entre ${startDate} - ${endDate}`,
  dateIsDisabled: 'Día no permitido',
  previous: 'Anterior',
  next: 'Siguiente',
  typeInDate: 'Escribir fecha',
  pickDateFromCalendar: 'Seleccionar fecha del calendario',
  close: 'Cerrar'
};
export default es;
//# sourceMappingURL=es.js.map